module.exports = __webpack_public_path__ + "media/images/steps/step_4-5772938e6dc6f7056f93686727ce215c.svg";